import apiAsync from 'infrastructure/shared/api/api-async'

import {
  PostWorkflowPayload,
  PostWorkflowResponse,
  FetchWorkflowResponse
} from '../types'

export const fetchWorkflow = (
  workflowUuid: string | undefined,
  showLoading = true
): Promise<FetchWorkflowResponse> => {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: `workflows/${workflowUuid}`,
    method: 'GET',
    showLoading: showLoading
  })
}

export const postWorkflow = (
  payload: PostWorkflowPayload,
  showLoading = true
): Promise<PostWorkflowResponse> => {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'workflows',
    method: 'POST',
    showLoading: showLoading,
    obj: {
      workflowmodel_uuid: payload.workflowmodel_uuid,
      data_container: {
        CLIENT_TRACKING: payload.clientTracking,
        ...payload.dataContainerParams
      }
    }
  })
}
